module.exports = __webpack_public_path__ + "55db8612c76421607611b3d39e07b279.svg";